import { ChangeDetectorRef, Component, Inject, Input, OnInit, Type, ViewChildren, QueryList, OnDestroy, inject } from '@angular/core';

import { PaginatorModule } from 'primeng/paginator';
import { NgComponentOutlet } from '@angular/common';
import { RouterModule } from '@angular/router';

import { Subscription } from 'rxjs';
import {
  DCFilterBarComponent,
  ICustomFilter,
  OnActionEvent,
  PaginationBase,
  PColumn,
  QuickTableComponent,
  TOAST_ALERTS_TOKEN,
  ListFilterBarOptions,
} from '@dataclouder/ngx-core';

import { LESSONS_TOKEN } from '../../lesson-mini-components/components/lessons.clases';
import { DcLessonCardComponent } from '../dc-lesson-card/dc-lesson-card.component';
import { DefaultLessonsService } from '../../../services/default-lessons.service';
import { MenuItem } from 'node_modules/primeng/api/menuitem';

const tableViewColumns: PColumn[] = [
  { field: 'media.images[0].url', header: 'Image', type: 'image' },
  { field: 'title', header: 'Título' },
  { field: 'description', header: 'Descripción' },
];

const TableViewActions: MenuItem[] = [
  { title: 'select', label: 'Select', icon: 'pi pi-check', severity: 'primary' },
  { title: 'qr', label: 'QR', icon: 'pi pi-qrcode', severity: 'info' },
  { title: 'edit', label: 'Edit', icon: 'pi pi-pencil', severity: 'info' },
  { title: 'delete', label: 'Delete', icon: 'pi pi-trash', severity: 'danger' },
];

const returnProperties: Record<string, 0 | 1> = {
  id: 1,
  level: 1,
  title: 1,
  description: 1,
  createdDate: 1,
  banner: 1,
  metadata: 1,
  appExtensions: 1,
  media: 1,
};

@Component({
  selector: 'dc-lesson-list',
  templateUrl: './dc-lesson-list.component.html',
  styleUrls: ['./dc-lesson-list.component.scss'],
  standalone: true,
  imports: [RouterModule, DCFilterBarComponent, PaginatorModule, NgComponentOutlet, QuickTableComponent],
})
export class DCLessonListComponent extends PaginationBase implements OnInit, OnDestroy {
  @Input() public showOptions: boolean = true;
  @Input() public customCardComponent?: Type<DcLessonCardComponent>;
  @Input() public customFilters: ICustomFilter[] = [];
  @Input() public viewType: 'table' | 'cards' = 'cards';

  // Injected Services
  public cdr = inject(ChangeDetectorRef);
  public lessonsService = inject(LESSONS_TOKEN, { optional: true }) ?? inject(DefaultLessonsService);
  public toastrService = inject(TOAST_ALERTS_TOKEN);

  public filterBarOptions: ListFilterBarOptions;

  public override columns: PColumn[] = tableViewColumns;

  @ViewChildren('outlet') outlets!: QueryList<NgComponentOutlet>;

  public cardComponent: Type<DcLessonCardComponent> = null;
  public cardEventSubs: Subscription[] = [];

  public lessons: any[] = [];
  public isLoadingLessons = false;

  ngOnInit(): void {
    this.filterConfig.returnProps = returnProperties;
    this.cardComponent = this.customCardComponent || DcLessonCardComponent;
    // TODO: i think show options is for admin, but refactor to add ListFilterBarOptions
    this.filterBarOptions = { showCreateButton: this.showOptions, showViewButton: this.showOptions, showActions: this.showOptions };
    this.getPaginatedLessons(this.filterConfig);
  }

  public subscribeDinamicInstantToEvents() {
    this.clearcardEventSubs();
    this.subscribeToCardEvents();
  }

  private subscribeToCardEvents() {
    this.outlets.forEach((outlet) => {
      const instance: DcLessonCardComponent = outlet.componentInstance;

      this.cardEventSubs.push(
        instance.onAction.subscribe((lesson: any) => {
          this.doOrEmitAction(lesson);
        }),
      );
    });
  }

  private clearcardEventSubs() {
    this.cardEventSubs.forEach((sub) => sub.unsubscribe());
    this.cardEventSubs = [];
  }

  ngOnDestroy() {
    this.clearcardEventSubs();
  }

  public async getPaginatedLessons(paginator: any) {
    try {
      this.lessons = null;
      this.isLoadingLessons = true;
      this.cdr.detectChanges();
      const lessons = await this.lessonsService.getLessons(paginator);

      this.lessons = lessons['rows'] || lessons;
      this.totalRecords = lessons['count'] || this.lessons.length;

      console.log('lessons', lessons);

      setTimeout(() => {
        this.subscribeDinamicInstantToEvents();
      });
    } finally {
      this.isLoadingLessons = false;
      this.cdr.detectChanges();
    }
  }

  public search(searchText: string) {
    this.filterConfig['text'] = searchText;
    this.getPaginatedLessons(this.filterConfig);
  }

  private removeLesson(lesson: any) {
    const response = confirm('¿Estás seguro de querer eliminar esta lección?');
    if (response) {
      this.lessonsService.deleteLesson(lesson._id);
      this.lessons = this.lessons.filter((l) => l._id !== lesson._id);
      this.cdr.detectChanges();
      this.toastrService.success({ title: 'Adios a la lección', subtitle: 'La lección ha sido eliminada correctamente' });
    }
  }

  public newLesson() {
    this.onAction.emit({ action: 'new' });
  }

  public applyFilterBarEvent(filterEvent: OnActionEvent) {
    if (filterEvent.action == 'changeView') {
      this.viewType = this.viewType === 'table' ? 'cards' : 'table';
      return;
    } else {
      console.log('filterChanged in dc-lesson-list', filterEvent);
      this.filterConfig = filterEvent.item;
      this.filterConfig.returnProps = returnProperties;

      this.getPaginatedLessons(this.filterConfig);
    }
  }

  protected override loadData(): Promise<void> {
    return this.getPaginatedLessons(this.filterConfig);
  }

  public doOrEmitAction(actionEvent: OnActionEvent) {
    if (actionEvent.action === 'delete') {
      this.removeLesson(actionEvent.item);
    } else {
      this.onAction.emit(actionEvent);
    }
  }
}
